// Returns a percentage css string value from a fraction
// Top refers to dividend and bottom refers to divisor
export function fractionToPercent(top: number, bottom: number): string {
  return `calc(100% * (${top} / ${bottom}))`;
}

export const darkOrLightStyle =
  ({ isOnDark }: { isOnDark?: boolean } = { isOnDark: false }) =>
  (darkStyle: string, lightStyle: string, isImportant?: boolean): string => {
    return `${isOnDark ? darkStyle : lightStyle}${
      isImportant ? '!important' : ''
    }`;
  };
